<template>
  <div
    style="height: 100vh;overflow-y: scroll;scrollbar-color: #e74c3c #f1f1f1;margin: 0 auto;width: 100%;max-width: 100vw;"
  >
    <div class="win-content">
      <img :src="imgList.bg" alt="" style="width: 100%;" class="win-img" />
      <img
        src="https://baoanlailou-online.oss-cn-beijing.aliyuncs.com/newActive/indexTop.gif"
        alt=""
        class="win-gif"
      />
      <img src="../../../static/btn3.png" alt="" class="win-logo" />
      <div class="win-title">
        <div v-if="list.length > 0" class="win-title-scroll-wrapper">
          <div
            class="win-title-scroll"
            :class="{ scrolling: list.length > 2 }"
            :style="{ animationDuration: animationDuration }"
          >
            <div
              class="win-title-text"
              v-for="(item, index) in scrollList"
              :key="index"
            >
              <div class="win-title-text-left">
                <div>第{{ item.roundNo }}期</div>
                <div style="margin-left: 20px;">{{ item.phone }}</div>
              </div>
              <div>{{ item.amount }}元</div>
            </div>
          </div>
        </div>
        <div v-else style="margin-top: 10px;">暂无中奖信息</div>
      </div>
      <div class="btnBox">
        <img
          src="../../../static/btn1.png"
          alt=""
          style="width: 166px;"
          @click="openRuleDialog"
        />
        <img
          src="../../../static/btn2.png"
          alt=""
          style="width: 166px;"
          @click="openCustomerService"
        />
      </div>
    </div>

    <!-- 活动规则弹窗 -->
    <div class="rule-mask" v-if="showRuleDialog" @click="closeRuleDialog"></div>
    <div class="rule-dialog" v-if="showRuleDialog">
      <div class="rule-dialog-content">
        <div class="rule-close" @click="closeRuleDialog">×</div>
        <div class="rule-title">
          <span class="rule-title-line"></span>
          <span>活动规则</span>
          <span class="rule-title-line1"></span>
        </div>
        <div class="rule-content">
          <p v-html="ruleText"></p>
        </div>
      </div>
    </div>

    <!-- 中奖弹窗 -->
    <div class="result-mask" v-if="showWinDialog"></div>
    <div class="result-dialog" v-if="showWinDialog">
      <img :src="imgList.win" alt="" class="result-bg" />
      <img
        src="../../../static/btn4.png"
        alt=""
        class="result-btn"
        @click="onWinBtnClick"
        v-if="status == '1'"
      />
      <div class="result-text" v-if="status == '2'">
        已过24小时，红包无法领取
      </div>
      <img
        src="../../../static/btn5.png"
        alt=""
        class="result-btn1"
        v-if="status == '2'"
      />
      <div
        class="result-text1"
        @click="onWinSuccessBtnClick"
        v-if="status == '3'"
      >
        已领奖，<span class="result-text2">去提现>></span>
      </div>
      <div class="result-close" @click="closeWinDialog">
        <img src="../../../static/closeImg.png" alt="" />
      </div>
    </div>

    <!-- 未中奖弹窗 -->
    <div class="result-mask" v-if="showNoWinDialog"></div>
    <div class="result-dialog" v-if="showNoWinDialog">
      <img :src="imgList.noWin" alt="" class="result-bg" />
      <div class="result-close" @click="closeNoWinDialog">
        <img src="../../../static/closeImg.png" alt="" />
      </div>
    </div>

    <!-- 领取成功弹窗 -->
    <div class="result-mask" v-if="showWinSuccessDialog"></div>
    <div class="win-success-dialog" v-if="showWinSuccessDialog">
      <img src="../../../static/winSuccess.png" alt="" class="win-success-bg" />
      <div class="win-success-close" @click="closeWinSuccessDialog">
        ×
      </div>
      <div class="win-success-content">
        <div class="win-success-title">领取成功</div>
        <div class="win-success-desc">
          {{ info.amount }}元现金已发放到您的咖德安保钱包，请及时查看！
        </div>
        <div class="win-success-btn" @click="onWinSuccessBtnClick">
          马上去查看
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: "SvgLotteryWheel",
  data() {
    return {
      imgList: {},
      showRuleDialog: false,
      showWinDialog: false,
      showNoWinDialog: false,
      showWinSuccessDialog: false,
      activeID: "",
      ruleText: "",
      status: "", // 1:显示领取按钮 2:显示过期按钮 3:显示已领取
      info: {},
      list: []
    };
  },
  computed: {
    scrollList() {
      // 如果数据超过 2 条，复制一份实现无缝循环
      if (this.list.length > 2) {
        return [...this.list, ...this.list];
      }
      return this.list;
    },
    // 根据数据量动态计算动画时间，保持滚动速度一致
    animationDuration() {
      // 每条数据滚动 5 秒，保证速度均匀
      return `${this.list.length}s`;
    }
  },
  mounted() {
    this.getSys();
    // 初始化微信 JSSDK
    this.initWeChatJSSDK();
    this.activeID = this.$route.query.id;
    if (this.$route.query.token) {
      localStorage.setItem("TOKEN", this.$route.query.token);
      this.token = this.$route.query.token;
      this.gettext();
      this.getInfo();
      this.getList();
    } else {
      // 非小程序环境，调用原生方法获取用户信息
      // 小程序环境已在小程序端判断登录状态，未登录不会进入此页面
      this.clickAskari();
      window.setUserInfo = val => {
        try {
          let obj = JSON.parse(val);
          let token = obj.loginUserVO.accessToken;
          localStorage.setItem("TOKEN", token);
          this.gettext();
          this.getInfo();
          this.getList();
        } catch (error) {
          console.error("请求失败:", error);
        }
      };
    }
  },
  methods: {
    getList() {
      this.$axios
        .post(`/mapi/api/activity/miniapp/draw/winners/list`, {
          activityId: this.activeID
        })
        .then(({ data }) => {
          this.list = data;
        });
    },
    getInfo() {
      this.$axios
        .post(`/mapi/api/activity/miniapp/draw/winner/query`, {
          activityId: this.activeID
        })
        .then(({ data }) => {
          this.info = data;
          if (data.drawn == true) {
            if (data.hasWon == true) {
              this.showWinDialog = true;
              if (data.canClaim == true) {
                this.status = "1";
              }
              if (data.grantStatus == 1) {
                this.status = "3";
              }
              if (data.grantStatus == 3) {
                this.status = "2";
              }
            } else {
              this.showNoWinDialog = true;
            }
          }
        });
    },
    onWinBtnClick() {
      // TODO: 添加领奖逻辑
      this.$axios
        .post(`/mapi/api/activity/miniapp/draw/prize/claim`, {
          activityId: this.activeID,
          winnerId: this.info.winnerId
        })
        .then(({ data }) => {
          this.closeWinDialog();
          this.openWinSuccessDialog();
        });
    },
    getSys() {
      this.$axios
        .post(`/mapi/api/common/by/prop-name`, {
          propName: "RandomDrawBackgroundImage"
        })
        .then(({ data }) => {
          let obj = JSON.parse(data.sysConfVO[0].propValue);
          this.imgList = obj;
        });
    },
    gettext() {
      this.$axios
        .post(`/mapi/api/activity/rule`, {
          activityId: this.activeID
        })
        .then(({ data }) => {
          // 将字符串形式的 \n 替换为 <br> 标签
          this.ruleText = data.ruleDesc.replace(/\\n/g, "<br>");
        });
    },
    // 初始化微信 JSSDK
    initWeChatJSSDK() {
      console.log("initWeChatJSSDK called");
      if (window.wx) {
        wx.ready(() => {
          console.log("wx.ready called");
          // 分享给朋友
          wx.updateAppMessageShareData({
            title: "好运两天一开，好活儿随时等你来",
            desc: "注册咖德安保App或小程序，参与抽奖赢现金红包！",
            link: window.location.href,
            imgUrl: this.imgList.shareImg || "",
            success: () => {
              console.log("分享给朋友成功");
            }
          });
          // 分享到朋友圈
          wx.updateTimelineShareData({
            title: "好运两天一开，好活儿随时等你来",
            link: window.location.href,
            imgUrl: this.imgList.shareImg || "",
            success: () => {
              console.log("分享到朋友圈成功");
            }
          });
          // 开启分享菜单
          wx.showShareMenu({
            withShareTicket: true,
            menus: ["shareAppMessage", "shareTimeline"]
          });
        });
        wx.error(res => {
          console.error("wx.error:", res);
        });
      } else {
        console.log("wx not available (非小程序环境)");
      }
    },
    //去钱包页面
    goDetail() {
      if (this.detectMobileOS() == "WeChatMiniProgram") {
        if (window.wx && window.wx.miniProgram) {
          window.wx.miniProgram.navigateTo({
            url: "/pages/wallet/wallet"
          });
        }
      } else if (this.detectMobileOS() == "Android") {
        Android.startMyWallet();
      } else {
        window.webkit.messageHandlers["startMyWallet"].postMessage("H5回调");
      }
    },
    callAndroid1() {
      Android.transactionDetails();
    },
    callIOS1() {
      window.webkit.messageHandlers["transactionDetails"].postMessage("H5回调");
    },
    // 打开活动规则弹窗
    openRuleDialog() {
      this.showRuleDialog = true;
    },
    // 关闭活动规则弹窗
    closeRuleDialog() {
      this.showRuleDialog = false;
    },
    // 打开中奖弹窗
    openWinDialog() {
      this.showWinDialog = true;
    },
    // 关闭中奖弹窗
    closeWinDialog() {
      this.showWinDialog = false;
    },

    // 打开未中奖弹窗
    openNoWinDialog() {
      this.showNoWinDialog = true;
    },
    // 关闭未中奖弹窗
    closeNoWinDialog() {
      this.showNoWinDialog = false;
    },
    // 打开领取成功弹窗
    openWinSuccessDialog() {
      this.showWinSuccessDialog = true;
    },
    // 关闭领取成功弹窗
    closeWinSuccessDialog() {
      this.showWinSuccessDialog = false;
    },
    // 领取成功按钮点击
    onWinSuccessBtnClick() {
      this.closeWinSuccessDialog();
      this.closeWinDialog();
      this.goDetail();
    },
    // 打开客服
    openCustomerService() {
      if (this.detectMobileOS() == "WeChatMiniProgram") {
        // 微信小程序环境，跳转到小程序的客服页面
        if (window.wx && window.wx.miniProgram) {
          window.wx.miniProgram.navigateTo({
            url: "/pages/customer-service/customer-service"
          });
        }
      } else if (this.detectMobileOS() == "Android") {
        Android.startCustomerService();
      } else {
        window.webkit.messageHandlers["startCustomerService"].postMessage(
          "H5回调"
        );
      }
    },
    OnShare() {
      if (this.detectMobileOS() == "IOS") {
        this.callIOS();
      } else if (this.detectMobileOS() == "Android") {
        this.callAndroid();
      } else if (this.detectMobileOS() == "WeChatMiniProgram") {
        this.callWeChatMiniProgram("share");
      }
    },
    callWeChatMiniProgram(action, data = {}) {
      console.log(
        "callWeChatMiniProgram called, action:",
        action,
        "data:",
        data
      );
      console.log("window.wx:", window.wx);
      console.log("window.wx.miniProgram:", window.wx && window.wx.miniProgram);

      // 微信小程序需要使用 wx.miniProgram.navigateTo 立即触发
      if (window.wx && window.wx.miniProgram) {
        const messageData = {
          action: action,
          ...data
        };
        console.log("Sending message:", messageData);

        // 使用 navigateTo 跳转到小程序的消息处理页，实现立即响应
        window.wx.miniProgram.navigateTo({
          url: `/pages/message-handler/message-handler?data=${encodeURIComponent(
            JSON.stringify(messageData)
          )}`
        });

        console.log("navigateTo sent successfully");
      } else {
        console.error("wx.miniProgram not available");
        // 降级方案：使用标准 postMessage
        window.postMessage(
          {
            action: action,
            ...data
          },
          "*"
        );
      }
    },
    saveImg() {
      if (this.detectMobileOS() == "IOS") {
        try {
          let obj = window.webkit.messageHandlers["imageClick"].postMessage(
            this.imageUrl
          );
        } catch (error) {
          console.error("请求失败:", error);
        }
      } else if (this.detectMobileOS() == "WeChatMiniProgram") {
        console.log("Calling WeChatMiniProgram saveImage");
        this.callWeChatMiniProgram("saveImage", { imageUrl: this.imageUrl });
      } else {
        Android.imageClick(this.imageUrl);
      }
    },
    detectMobileOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      console.log("UserAgent:", userAgent);

      // Windows Phone必须放在前面，因为它的UA也包含"Android"
      if (/windows phone/i.test(userAgent)) return "Windows Phone";

      // 微信小程序检测（必须在普通浏览器检测之前）
      if (/MicroMessenger/i.test(userAgent) && /miniProgram/i.test(userAgent)) {
        console.log("Detected: WeChatMiniProgram");
        return "WeChatMiniProgram";
      }

      if (/android/i.test(userAgent)) {
        console.log("Detected: Android");
        return "Android";
      }

      // iOS检测
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        console.log("Detected: IOS");
        return "IOS";
      }
      console.log("Detected: Unknown");
      return "Unknown";
    },
    clickAskari() {
      if (this.detectMobileOS() == "IOS") {
        // 检查 window.webkit 是否存在（只有在 iOS App 的 WebView 中才有）
        if (window.webkit && window.webkit.messageHandlers) {
          try {
            window.webkit.messageHandlers["getUserInfo"].postMessage(
              "H5获取用户信息"
            );
          } catch (error) {
            console.error("请求失败:", error);
          }
        } else {
          console.log(
            "window.webkit.messageHandlers 不可用，当前可能不是 iOS App 环境"
          );
        }
      } else if (this.detectMobileOS() == "WeChatMiniProgram") {
        this.callWeChatMiniProgram("getUserInfo");
      } else {
        // Android 环境也需要检查 Android 对象是否存在
        if (typeof Android !== "undefined" && Android.getUserInfo) {
          Android.getUserInfo("来自 JavaScript 的消息");
        } else {
          console.log("Android 对象不可用，当前可能不是 Android App 环境");
        }
      }
    }
  }
};
</script>

<style scoped>
.win-title {
  position: absolute;
  top: 57%;
  left: 50%;
  transform: translate(-50%, -57%);
  width: 91%;
  height: 98px;
  text-align: center;
  color: #a0270c;
  font-size: 12px;
  background-image: url("../../../static/listBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 40px;
  box-sizing: border-box;
  overflow: hidden;
}

.win-title-scroll-wrapper {
  height: 48px;
  overflow: hidden;
}

.win-title-scroll {
  display: flex;
  flex-direction: column;
}

.win-title-scroll.scrolling {
  animation: scrollUp linear infinite;
}

@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-50%);
  }
}

.win-title-text {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
  box-sizing: border-box;
  font-weight: 500;
  height: 24px;
  flex-shrink: 0;
}
.win-title-text-left {
  display: flex;
  align-items: center;
}

.win-logo {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  width: 90px;
  height: 32px;
}
/* animation: pulse 1.2s ease-in-out infinite; */
@keyframes pulse {
  0%,
  100% {
    transform: translateX(-50%) scale(1);
  }
  50% {
    transform: translateX(-50%) scale(1.08);
  }
}
.win-content {
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
}
.win-img {
  display: block;
  width: 100%;
}
.win-gif {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
}
.btnBox {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  bottom: 17px;
  left: 0;
  width: 100%;
  z-index: 3;
}

/* 活动规则弹窗样式 */
.rule-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
}
.rule-dialog-content {
  width: 100%;
  height: 100%;
  padding: 10px 10px;
  box-sizing: border-box;
  border: 2px dashed rgba(255, 255, 255, 0.6);
  border-radius: 16px;
}
.rule-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  max-width: 400px;
  height: 70vh;
  background: #f0885a;
  border-radius: 16px;
  padding: 10px 10px;
  box-sizing: border-box;
  z-index: 101;
  overflow-y: auto;
}

.rule-close {
  position: absolute;
  top: 15px;
  right: 20px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
  line-height: 1;
  font-weight: 300;
}

.rule-close:hover {
  opacity: 0.8;
}

.rule-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.rule-title-line {
  flex: 1;
  width: 20px;
  height: 2px;
  background: linear-gradient(270deg, #ffffff 0%, #ff663d 100%);
  border-radius: 1px;
  max-width: 30px;
}
.rule-title-line1 {
  flex: 1;
  width: 20px;
  height: 2px;
  background: linear-gradient(270deg, #ff663d 0%, #ffffff 100%);
  border-radius: 1px;
  max-width: 30px;
}

.rule-title span:nth-child(2) {
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  margin: 0 15px;
  white-space: nowrap;
}

.rule-content {
  color: #fff;
  font-size: 14px;
  line-height: 1.8;
}

.rule-content p {
  margin: 0;
  white-space: pre-wrap; /* 保留换行符 */
}

/* 中奖/未中奖弹窗样式 */
.result-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 200;
}

.result-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 450px;
  z-index: 201;
}

.result-bg {
  width: 100%;
  display: block;
  border-radius: 16px;
}

.result-btn {
  position: absolute;
  bottom: 80px;
  left: 50%;
  transform: translateX(-50%);
  width: 123px;
  cursor: pointer;
  animation: pulse 1.2s ease-in-out infinite;
}
.result-btn1 {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  width: 123px;
  cursor: pointer;
}
.result-text {
  width: 100%;
  position: absolute;
  bottom: 110px;
  left: 0;
  text-align: center;
  color: #fffbc4;
  font-size: 12px;
}
.result-text1 {
  width: 100%;
  position: absolute;
  bottom: 90px;
  left: 0;
  text-align: center;
  color: #fff;
  font-size: 16px;
}
.result-text2 {
  text-decoration: underline;
}
.result-close {
  position: absolute;
  bottom: -60px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.result-close img {
  width: 100%;
  height: 100%;
}

/* 领取成功弹窗样式 */
.win-success-dialog {
  height: 308px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  padding: 30px 20px;
  box-sizing: border-box;
  z-index: 201;
  text-align: center;
}

.win-success-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
  z-index: -1;
}

.win-success-close {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.win-success-close img {
  width: 100%;
  height: 100%;
}

.win-success-content {
  position: relative;
  z-index: 1;
  margin-top: 80px;
}

.win-success-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

.win-success-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 30px;
  padding: 0 10px;
}

.win-success-btn {
  width: 100%;
  height: 50px;
  background: #3b82f6;
  color: #fff;
  font-size: 18px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.3s;
}

.win-success-btn:hover {
  opacity: 0.9;
}
</style>



// WEBPACK FOOTER //
// src/view/win/win.vue